<template>
    <div class="one">
        <!-- 机型 -->
        <div class="logo-top">
            <p>纸搬客智能回收机001型</p>
        </div>
        <!-- 型号 -->
        <div class="common-border model">
            <h2 class="common-h2-1">纸搬客智能回收机001型</h2>
            <img src="../assets/img/userMethods/1.png" alt="" class="animated bounceInUp">
        </div>
        <!-- 智能 -->
        <div class="common-border intelligence">
            <h2>"智能"如其名</h2>
            <p>首创的粉碎型废纸回收机，在原有的垃圾回收基础上</p>
            <p>更加注重效率及隐私保护。内置的纸搬客自研机芯可将用户投递</p>
            <p>的纸张粉碎后放入桶内。智能电子秤将以克为单位计算重量，积分</p>
            <p>立即到账。环保，有偿更有趣。</p>
            <div class="small" @click="top">向下滑动<img src="../assets/img/userMethods/10.png" alt=""></div>
        </div>
        <!-- 步骤 -->
        <div class="common-border step-1">
            <div class="step-left">
                <img src="../assets/img/userMethods/2.png" alt="" class="img-1">
            </div>
            <div class="step-center">
                <img src="../assets/img/userMethods/3.png" alt="" class="img-2">
            </div>
            <div class="step-right">
                <img src="../assets/img/userMethods/4.png" alt="" class="img-3">
            </div>
        </div> 
        <!-- 会说话才够智能 -->
        <div class="common-border speak">
            <div class="speak-left">
                <h2>会"说话"才够智能</h2>
                <p>15.6英寸的智慧大屏，内置纸搬客智能语音交互系统，代号-“小绿箱”，碎纸过程中实时播报状态，称重后播报所获积分及收益。下次碎纸，请对它说“Hi”。</p>
            </div>
            <div class="speak-right">
                <img src="../assets/img/userMethods/5.png" alt="">
            </div>
        </div>
        <!-- 智能不止于此 -->
        <div class="common-border just">
            <div class="just-left">
                <img src="../assets/img/userMethods/6.png" alt="">
            </div>
            <div class="just-right">
                <h2 class="common-h2">智能不止于此</h2>
                <p>设备运转时将进入“哨兵”模式，结合入纸通道内置智能传感器可识别人体，当手到达安全界限后，自动启动保护机制够安全，才智能。</p>
            </div>
        </div>
        <!-- 安全不仅于此 -->
        <div class="common-border safe">
            <h2>安全不仅于此</h2>
            <p>设备上方外置红外线安全摄像头，将在设备静置时、启动时，配合小绿箱语音交互系统及“哨兵模式”进行360°无死角安全监控。红外，夜拍更清晰。</p>
            <img src="../assets/img/userMethods/7.png" alt="">
        </div>
        <!-- 不说话也能清楚表达我在手里才更安全 -->
        <div class="common-border noSpeak">
            <div class="noSpeak-left">
                <h2>不说话也能清晰表达<br>握在手里才更安全</h2>
                <p>外置设备安全home键，发生意外，轻轻一按，“哨兵”强制进入安全管理状态，设备停机并自动向后台发出安全预警。</p>
            </div>
            <div class="noSpeak-right">
                <img src="../assets/img/userMethods/8.png" alt="">
            </div>
        </div>
        <!-- 风吹雨打?靠得住 -->
        <div class="common-border windRain">
            <div class="windRain-left">
                <img src="../assets/img/userMethods/9.png" alt="">
            </div>
            <div class="windRain-right">
                <h2 class="common-h2">风吹雨打?&nbsp;靠得住</h2>
                <p>外置挡雨顶棚，机身采用防水材质。</p>
            </div>
        </div>
        <!-- 没有多言的,才是最强的 -->
        <div class="common-border strong">
            <h2 class="common-h2">没有多言的,&nbsp;才是最强的</h2>
            <ul class="strong-last">
                <li>
                    <img src="../assets/img/userMethods/11.png" alt="" class="img-4">
                    <h3>金属机制</h3>
                    <p>内部结构进行重量配比，安全更牢固</p>
                </li>
                <li>
                    <img src="../assets/img/userMethods/12.png" alt="" class="img-5">
                    <h3>GPS定位</h3>
                    <p>智慧大屏内置精准定位模块，为用户</p>
                    <p>推荐最近最合适的设备</p>
                </li>
                <li>
                    <img src="../assets/img/userMethods/13.png" alt="" class="img-6">
                    <h3>220V弱电驱动</h3>
                    <p>适应性更强，更安全</p>
                </li>
                <li>
                    <img src="../assets/img/userMethods/14.png" alt="" class="img-7">
                    <h3>断电保护</h3>
                    <p>不只是快，碎纸中断电将上报数据于</p>
                    <p>后台，保护性强，才称得上有偿</p>
                </li>
                <li>
                    <img src="../assets/img/userMethods/15.png" alt="" class="img-8">
                    <h3>远程交互</h3>
                    <p>设备将和纸搬客后台保持通讯</p>
                    <p>远程交互，既是智能，更是安全</p>
                </li>
                <li>
                    <img src="../assets/img/userMethods/16.png" alt="" class="img-9">
                    <h3>系统升级</h3>
                    <p>内置纸搬客自研回收系统，定期进行系</p>
                    <p>统升级，软硬结合，才是物联</p>
                </li>
            </ul>
        </div>
        <!-- 纸搬客，让环保  不止于此 -->
        <div class="common-border environmental">
            <div class="environmental-left">
                <h3>纸搬客，让环保&nbsp&nbsp&nbsp&nbsp;不止于此</h3>
                <h2>纸搬客碎纸机001型</h2>
            </div>
            <div class="environmental-right">
                <img src="../assets/img/userMethods/1.png" alt="">
            </div>
        </div>
        <footer_s></footer_s>
    </div>
</template>

<script>
    import $ from 'jquery'
    import footer_s from './common/footer'
    export default {
        name: 'one',
        components:{
            footer_s,
        },
        data() {
            return {
            }
        },
        mounted(){
            $(function(){
                $('.common-h2-1').animate({
                    opacity: 1
                },2000)
                $(window).scroll(function(){
                    var scrollT=$(window).scrollTop(); //滚动的高度
                    var ViewHeight = $(window).height(); //视口的高度
                    var ModelHeight = $('.model').offset().top; //元素的高度
                    var intelligenceHeight=$('.intelligence').offset().top;
                    var StepHeight=$('.step-1').offset().top;
                    var SpeakHeight=$('.speak').offset().top;
                    var JustHeight=$('.just').offset().top;
                    var SafeHeight=$('.safe').offset().top;
                    var noSpeakHeight=$('.noSpeak').offset().top;
                    var windRainHeight=$('.windRain').offset().top;
                    var strongHeight=$('.strong').offset().top;
                    var environmentalHeight=$('.environmental').offset().top;
                    if (scrollT + ViewHeight >= intelligenceHeight) {
                        $('.intelligence h2,.intelligence p').animate({
                            opacity: 1
                        }, 2000)
                    } 
                    if (scrollT + ViewHeight >= StepHeight) {
                        $('.step-left img').addClass('animated fadeInLeftBig')
                        $('.step-center img').addClass('animated fadeInUpBig')
                        $('.step-right img').addClass('animated fadeInRightBig')
                    }
                    if (scrollT + ViewHeight >= SpeakHeight) {
                        $('.speak-right img').addClass('animated fadeInRightBig')
                        $('.speak-left h2,.speak-left p').addClass('animated fadeInLeftBig').animate({
                            opacity: 1
                        }, 2000)
                    }
                    if (scrollT + ViewHeight >= JustHeight) {
                        $('.just-left img').addClass('animated zoomInLeft')
                        $('.just-right h2,.just-right p').addClass('animated zoomInRight').animate({
                            opacity: 1
                        }, 2000)
                    }
                    if (scrollT + ViewHeight >= SafeHeight) {
                        $('.safe h2,.safe p').animate({
                            opacity: 1
                        }, 2000)
                        $('.safe img').addClass('animated fadeInUp')
                    }
                    if (scrollT + ViewHeight >= noSpeakHeight) {
                        $('.noSpeak-right img').addClass('animated bounceInRight')
                        $('.noSpeak-left h2,.noSpeak-left p').addClass('animated zoomInLeft').animate({
                            opacity: 1
                        }, 2000)
                    }
                    if (scrollT + ViewHeight >= windRainHeight) {
                        $('.windRain-left img').addClass('animated bounceInLeft')
                        $('.windRain-right h2,.windRain-right p').addClass('animated zoomInLeft').animate({
                            opacity: 1
                        }, 2000)
                    }
                    if (scrollT + ViewHeight >= strongHeight) {
                        $('.strong-last li:nth-of-type(1),.strong-last li:nth-of-type(4)').addClass('animated bounceInLeft')
                        $('.strong-last li:nth-of-type(2),.strong-last li:nth-of-type(5)').addClass('animated bounceInUp')
                        $('.strong-last li:nth-of-type(3),.strong-last li:nth-of-type(6 )').addClass('animated bounceInRight')
                        $('.strong h2').addClass('animated zoomInLeft').animate({
                            opacity: 1
                        }, 2000)
                    }
                    if (scrollT + ViewHeight >= environmentalHeight) {
                        $('.environmental-right img').addClass('animated zoomInLeft')
                        $('.environmental-left h2,.environmental-left h3').addClass('animated zoomInRight').animate({
                            opacity: 1
                        }, 2000)
                    }
                })
            })
        },
        methods:{
            top(){
                var scrollT=$(window).scrollTop(); //滚动的高度
                $(document).scrollTop(scrollT+120);
            }
        },
        beforeDestroy(){
            $(window).off('scroll')
        }
    }
</script>
<style scoped>
    .one {
        width: 100%;
        height: 100%;
        background-color: #000000;
    }

    .logo-top {
        width: 100%;
        height: 0.18rem;
        background-color: #0F0F0F;
    }

    .logo-top p {
        font-size: 0.05rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 0.18rem;
        margin-left: 0.7rem;
    }

    .common-border {
        border-left: 0.08rem solid #0F0F0F;
        border-right: 0.08rem solid #0F0F0F;
        border-bottom: 0.12rem solid #0f0f0f;
    }

    .common-h2-1 {
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        opacity: 0.3;
    }

    .model {
        position: relative;
        height: 1.94rem;
        padding-top: 0.16rem;
        background-color: #000000;
        z-index: 19;
    }

    .model h2 {
        font-size: 0.16rem;
        text-align: center;
    }

    .model img {
        width: 0.96rem;
        height: 1.29rem;
        position: absolute;
        top: 0.54rem;
        left: 50%;
        margin-left: -0.48rem;
    }

    .intelligence {
        height: 1.94rem;
        padding-top: 0.42rem;
        background-color: #000000;
    }

    .intelligence h2 {
        font-size: 0.16rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 0.11rem;
        text-align: center;
        opacity: 0;
    }

    .intelligence p {
        font-size: 0.07rem;
        font-family: PingFang SC;
        font-weight: bold;
        text-align: center;
        color: rgba(206, 206, 206, 1);
        line-height: 0.11rem;
        opacity: 0;
    }

    .intelligence .small {
        width: 0.69rem;
        height: 0.18rem;
        border: 0.01rem solid #fff;
        border-radius: 0.03rem;
        margin: 0 auto;
        margin-top: 0.14rem;
        font-size: 0.09rem;
        font-family: PingFang SC;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.15rem;
        cursor: pointer;
    }

    .small img {
        width: 0.09rem;
        height: 0.07rem;
        vertical-align: middle;
        margin-left: 0.07rem;
    }

    .step-1 {
        height: 1.94rem;
        overflow: hidden;
        background-color: #0F0F0F;
    }

    .step-left,
    .step-center,
    .step-right {
        width: 31%;
        height: 1.82rem;
        float: left;
        margin-right: 3.5%;
        background: #000000;
        position: relative;
    }

    .step-right {
        margin-right: 0;
    }

    .step-left .img-1 {
        width: 1.01rem;
        height: 1.35rem;
        position: absolute;
        top: 0.24rem;
        left: 50%;
        margin-left: -0.5rem;
    }

    .step-center .img-2 {
        width: 0.91rem;
        height: 0.43rem;
        position: absolute;
        top: 0.74rem;
        left: 50%;
        margin-left: -0.45rem;
    }

    .step-right .img-3 {
        width: 0.96rem;
        height: 1.32rem;
        position: absolute;
        top: 0.26rem;
        left: 50%;
        margin-left: -0.48rem;
    }

    .speak,
    .just {
        overflow: hidden;
        height: 1.94rem;
        background-color: #0F0F0F;
    }

    .speak-left,
    .just-right {
        width: 52%;
        height: 1.82rem;
        float: left;
        margin-right: 2%;
        padding-top: 0.65rem;
        background-color: #000000;
    }

    .speak-left h2 {
        font-size: 0.15rem;
        text-align: center;
        margin-bottom: 0.11rem;
        letter-spacing: 0.03rem;
        opacity: 0.3;
        color: rgba(255, 255, 255, 1);
    }

    .speak-left p {
        font-size: 0.05rem;
        text-align: center;
        line-height: 0.12rem;
        font-family: Microsoft YaHei;
        color: rgba(255, 255, 255, 1);
        padding: 0 0.1rem 0 0.06rem;
        font-weight: bold;
        opacity: 0.3;
    }

    .speak-right,
    .just-left {
        width: 46%;
        float: left;
        height: 1.82rem;
        position: relative;
        background-color: #000000;
    }

    .speak-right img {
        width: 1.41rem;
        height: 0.89rem;
        position: absolute;
        top: 0.47rem;
        left: 50%;
        margin-left: -0.7rem;
    }

    .just-left img {
        width: 1.43rem;
        height: 0.67rem;
        position: absolute;
        top: 0.58rem;
        left: 50%;
        margin-left: -0.71rem;
    }

    .just-left {
        margin-right: 2%;
    }

    .just-right {
        margin-right: 0;
    }

    .just-right h2 {
        text-align: center;
        font-size: 0.15rem;
        margin-bottom: 0.11rem;
        color: rgba(255, 255, 255, 1);
        opacity: 0.3;
    }

    .just-right p {
        text-align: center;
        font-size: 0.05rem;
        font-weight: bold;
        line-height: 0.12rem;
        margin: 0 0.12rem 0 0.13rem;
        font-family: Microsoft YaHei;
        color: rgba(255, 255, 255, 1);
        opacity: 0.3;
    }

    .safe {
        height: 1.94rem;
        padding-top: 0.14rem;
        position: relative;
        background-color: #000000;
    }

    .safe h2 {
        font-size: 0.16rem;
        margin: 0 0 0.1rem 0;
        text-align: center;
        color: rgba(255, 255, 255, 1);
        opacity: 0.3;
    }

    .safe p {
        text-align: center;
        font-size: 0.05rem;
        font-weight: bold;
        font-family: Microsoft YaHei;
        color: rgba(255, 255, 255, 1);
        line-height: 0.11rem;
        padding: 0 1rem 0 1.08rem;
        opacity: 0.3;
    }

    .safe img {
        width: 1.75rem;
        height: 0.97rem;
        position: absolute;
        top: 0.85rem;
        left: 50%;
        margin-left: -0.87rem;
    }

    .noSpeak,
    .windRain,.environmental {
        overflow: hidden;
        height: 1.94rem;
        background-color: #000000;
    }
   
    .noSpeak-left,
    .noSpeak-right,.environmental-left {
        width: 55%;
        height: 1.94rem;
        float: left;
    }

    .noSpeak-left h2,
    .windRain-right h2 {
        text-align: center;
        font-size: 0.15rem;
        margin: 0.3rem 0 0.1rem 0;
        color: rgba(255, 255, 255, 1);
        opacity: 0.3;

    }
    .environmental-left h2{
        font-size:0.17rem;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(255,255,255,1);
        margin-left: 0.23rem;
        opacity: 0.3;
    }
    .environmental-left h3{
        font-size:0.14rem;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:0.3rem;
        margin: 0.69rem 0 0 0.2rem;
        opacity: 0.3;
    }
    .noSpeak-left p,
    .windRain-right p {
        font-size: 0.05rem;
        font-weight: bold;
        text-align: center;
        line-height: 0.12rem;
        font-family: Microsoft YaHei;
        color: rgba(255, 255, 255, 1);
        padding: 0 0.36rem;
        opacity: 0.3;
    }
    .windRain-right p{
        padding: 0 0.3rem;
    }
    .noSpeak-right,.environmental-right {
        width: 45%;
        height: 1.94rem;
        position: relative;
        float: left;
    }

    .noSpeak-right img {
        width: 1.59rem;
        height: 0.88rem;
        position: absolute;
        bottom: 0;
        right: 0.06rem;
    }
    .environmental-right img{
        width: 1.05rem;
        height: 1.4rem;
        position: absolute;
        bottom: 0.12rem;
        right: 0.24rem;
    }
    .windRain-left {
        width: 58%;
        float: left;
        padding-top: 0.1rem;
    }

    .windRain-left img {
        width: 2.12rem;
        height: 1.78rem;
    }

    .windRain-right {
        width: 42%;
        float: left;
    }

    .windRain-right h2 {
        font-size: 0.15rem;
        letter-spacing: 0.01rem;
        margin: 0.63rem 0 0.1rem 0;
    }

    .windRain-right p {
        text-align: center;
        font-size: 0.05rem;
    }

    .strong {
        height: 1.94rem;
        padding-top: 0.1rem;
        background-color: #000;
    }

    .strong h2 {
        font-size: 0.16rem;
        margin: 0 0 0.15rem 0.10rem;
        color: rgba(255, 255, 255, 1);
        opacity: 0.3;
    }

    .strong-last {
        overflow: hidden;
    }

    .strong-last li {
        width: 30.3%;
        height: 0.6rem;
        float: left;
        padding-left: 2%;
        margin-left: 3%;
    }

    .strong-last li:nth-child(3) {
        margin-right: 0;
    }

    .strong-last li img {
        vertical-align: middle;
    }

    .img-4 {
        width: 0.16rem;
        height: 0.16rem;
        margin-bottom: 0.08rem;
    }

    .img-5 {
        width: 0.10rem;
        height: 0.13rem;
        margin-bottom: 0.11rem;
    }

    .img-6 {
        width: 0.12rem;
        height: 0.13rem;
        margin-bottom: 0.11rem;
    }

    .img-7 {
        width: 0.13rem;
        height: 0.13rem;
        margin: 0.07rem 0 0.08rem 0;
    }

    .img-8 {
        width: 0.11rem;
        height: 0.1rem;
        margin: 0.11rem 0 0.1rem 0;
    }

    .img-9 {
        width: 0.1rem;
        height: 0.1rem;
        margin: 0.1rem 0;
    }

    .strong-last li h3 {
        font-size: 0.06rem;
        font-family: PingFang SC;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 0.03rem;
    }

    .strong-last li p {
        font-size: 0.05rem;
        font-family: PingFang SC;
        color: rgba(150, 150, 150, 1);
        line-height: 0.1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/views/one.vue